<template>
  <button
    data-el="metrics"
    :data-id="dataId"
    :data-loading="loading ? '1' : '0'"
    :data-status="status"
    :data-label="label"
    type="button"
    :title="hover"
    :class="{
      'flex flex-row items-center': true,
      border: true,
      'rounded-lg': true,
      'border-gray-200 bg-white shadow-sm': true,
      'px-3.5 py-2 hover:bg-white hover:shadow': true,
    }"
    @click="onClick"
  >
    <span class="flex-1 text-left text-xs font-semibold text-gray-700">
      {{ title }}
    </span>
    <span>
      <ResourceLoading v-if="loading" size="sm" flush />
      <span class="flex flex-row items-center justify-center gap-3" v-else>
        <StatusBadge
          class="hidden lg:block"
          v-if="label"
          :label="label"
          :status="status"
          size="sm"
        />
        <StatusIcon :status="status" />
      </span>
    </span>
  </button>
</template>
<script setup lang="ts">
import { defineProps } from 'vue';
import type {
  NotificationMetricsStatusEnum,
  ReputationMetricsStatusEnum,
  SubscriptionMetricsStatusEnum,
} from '@mailslurp/admin-sdk';
import ResourceLoading from '../../components/charts/ResourceLoading.vue';
import StatusBadge from '../../components/alerts/StatusBadge.vue';
import StatusIcon from '../../components/alerts/StatusIcon.vue';
withDefaults(
  defineProps<{
    dataId: string;
    title: string;
    loading?: boolean;
    label?: string;
    hover: string;
    status:
      | NotificationMetricsStatusEnum
      | ReputationMetricsStatusEnum
      | SubscriptionMetricsStatusEnum;
  }>(),
  {
    loading: false,
    label: '',
  },
);
const emit = defineEmits<{ (event: 'click'): void }>();
const onClick = () => {
  emit('click');
};
</script>
